import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getApplicationSettings } from 'src/modules/applications/slices';
import { useErrorRecovery } from 'src/hooks/useErrorRecovery';
import ApplicationErrorBoundary from './ApplicationErrorBoundary';

const FeatureErrorBoundary = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const settings = useSelector(getApplicationSettings);
  const { recover, recoveryActionLabel, recoveryKey, showRecoveryAction } = useErrorRecovery();

  return (
    <ApplicationErrorBoundary
      settings={settings}
      context={`feature:${location.pathname}${location.search}`}
      onRecover={recover}
      recoveryActionLabel={recoveryActionLabel}
      showRecoveryAction={showRecoveryAction}
      fullScreen={false}
      showLogo={false}
      resetKey={recoveryKey}
    >
      {children}
    </ApplicationErrorBoundary>
  );
};

export default FeatureErrorBoundary;
